export enum KalaSymbolCategory {
	Ati = 'آتی',
	Govahi = 'گواهی‌سپرده',
	CallOption = 'اختیار معاملات خرید',
	PutOption = 'اختیار معاملات فروش'
}

export interface SymbolInfoData {
	totalTradeValue?: string | null;
	lastTradedPrice?: number | null;
	totalNumberOfSharesTraded?: string | null;
	closingPrice?: number | null;
	closingPriceChangePercent?: number | null;
	feeOfPreviousDaysClosingPrice?: number | null;
	lastCalculatedTradeTime?: string | null;
	tradeDate?: string | null;
	symbolCategory: KalaSymbolCategory;
	tradesCount?: number | null;
	closingPriceChange?: number | null;
}

export interface categoryMarketUnitColumn {
	rows: (symbolInfoField | null | undefined)[][];
}
export interface symbolInfoField {
	label: string;
	value: keyof SymbolInfoData;
	dir?: string | null;
	tooltip?: keyof SymbolInfoData;
}
export enum symbolInfoColumn {
	marketUnit,
	lastCalculatedTradeTime,
	totalTradeValue,
	totalNumberOfSharesTraded,
	lastTradedPrice,
	tradeDate,
	closingPrice,
	feeOfPreviousDaysClosingPrice,
	tradesCount
}

export const symbolInfoColumnField = new Map<symbolInfoColumn, symbolInfoField>([
	[
		symbolInfoColumn.lastCalculatedTradeTime,
		{
			label: 'زمان آخرین معامله',
			value: 'lastCalculatedTradeTime',
			dir: null,
			tooltip: 'tradeDate'
		}
	],
	[
		symbolInfoColumn.totalTradeValue,
		{
			label: 'ارزش معاملات',
			value: 'totalTradeValue',
			dir: 'ltr'
		}
	],
	[
		symbolInfoColumn.totalNumberOfSharesTraded,
		{
			label: 'حجم معاملات',
			value: 'totalNumberOfSharesTraded',
			dir: 'ltr'
		}
	],
	[
		symbolInfoColumn.closingPrice,
		{
			label: 'قیمت پایانی',
			value: 'closingPrice',
			dir: 'ltr'
		}
	],
	[
		symbolInfoColumn.feeOfPreviousDaysClosingPrice,
		{
			label: 'قیمت دیروز',
			value: 'feeOfPreviousDaysClosingPrice',
			dir: 'ltr'
		}
	],
	[
		symbolInfoColumn.tradesCount,
		{
			label: 'تعداد معاملات',
			value: 'tradesCount',
			dir: 'ltr'
		}
	]
]);

export const categoryMarketUnitColumns = new Map<KalaSymbolCategory, categoryMarketUnitColumn>([
	[
		KalaSymbolCategory.Govahi,
		{
			rows: [
				[symbolInfoColumnField.get(symbolInfoColumn.closingPrice)],
				[symbolInfoColumnField.get(symbolInfoColumn.feeOfPreviousDaysClosingPrice)],
				[symbolInfoColumnField.get(symbolInfoColumn.totalTradeValue)],
				[symbolInfoColumnField.get(symbolInfoColumn.totalNumberOfSharesTraded)],
				[symbolInfoColumnField.get(symbolInfoColumn.tradesCount)],
				[symbolInfoColumnField.get(symbolInfoColumn.lastCalculatedTradeTime)]
			]
		}
	],
	[
		KalaSymbolCategory.Ati,
		{
			rows: []
		}
	],
	[
		KalaSymbolCategory.CallOption,
		{
			rows: []
		}
	],
	[
		KalaSymbolCategory.PutOption,
		{
			rows: []
		}
	]
]);
